import React, { useState } from 'react'
import { Grid, Paper, Typography, Button } from '@material-ui/core'
import { useStyles, CssTextField } from './classes'
import axios from 'axios'
import Alert from '@material-ui/lab/Alert'
// validation
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { TextField } from 'formik-material-ui'

export default function Subscribe() {
  // data
  const [initialValues, setInitialValues] = useState({ // eslint-disable-line
    email: '',
  })

  const [alert, setAlert] = useState({
    showAlert: false,
    severity: 'success',
    message: '',
  })

  const submit = async (e, { resetForm }) => {
    try {
      await axios.post('/newsletter', e)
      resetForm()
      setAlert({
        showAlert: true,
        severity: 'success',
        message: 'You are subscribed to the newsletter',
      })
    } catch (error) {
      if (error.response.status === 422) {
        setAlert({
          showAlert: true,
          severity: 'error',
          message: 'You already subscribed to the newsletter',
        })
      } else {
        setAlert({
          showAlert: true,
          severity: 'error',
          message: 'failed!',
        })
      }
    }
  }

  // validation schema
  let validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Must be a valid email!')
      .max(320, 'Max length for the email is 320.'),
  })

  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <Grid container direction='column' justify='center' alignItems='center'>
          <Grid item xs={12} sm={12} md={12} >
            <Paper className={classes.paper} elevation={0}>
              <Typography className={classes.title}>
                Join Our Newsletter
              </Typography>
              <Formik
                initialValues={initialValues}
                onSubmit={submit}
                validationSchema={validationSchema}
                enableReinitialize>

                {({ isValid, dirty }) => {
                  return (
                    <Form>
                      <CssTextField
                        name='email'
                        fullWidth
                        component={TextField}
                        size='small'
                        variant="outlined"
                        placeholder='Email Address'
                      // className={classes.field}
                      />
                      <Button
                        variant='contained'
                        className={classes.button}
                        type='submit'
                        disabled={!dirty || !isValid}
                      >
                        Subscribe
              </Button>
                    </Form>
                  )
                }}
              </Formik>
            </Paper>
            {alert.showAlert && (
              <Grid item md={12}>
                <Alert
                  severity={alert.severity}
                  onClose={() =>
                    setAlert({
                      ...alert,
                      showAlert: false,
                    })
                  }
                >
                  {alert.message}
                </Alert>
              </Grid>
            )}
          </Grid>
        </Grid>
      </div>
    </>
  )
}
